/* @flow */
import * as React from "react";
import { lighten } from "polished";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";
import Switch from "./internal/Switch";
import UserAgent from "./UserAgent";
import { ACTIVE_DARKEN_AMOUNT } from "./Tappable";

type ChildToggleProps = {
  changeOnTap: ?boolean,
  checked: boolean,
  colors: ColorSet,
  onChange: (newValue: boolean) => void,
  disabled?: boolean,
  "aria-label"?: string,
};

class IOSToggle extends React.Component<ChildToggleProps> {
  render() {
    const {
      changeOnTap,
      checked,
      colors,
      onChange,
      disabled,
      "aria-label": ariaLabel,
    } = this.props;

    return (
      <Switch
        changeOnTap={changeOnTap}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        offColor="#888"
        onColor={colors.PRIMARY}
        offHandleColor="#fff"
        onHandleColor="#fff"
        activeBoxShadow={`0 0 2px 2px ${colors.PRIMARY}`}
        handleDiameter={22}
        height={24}
        width={40}
        aria-label={ariaLabel}
      />
    );
  }
}

class AndroidToggle extends React.Component<ChildToggleProps> {
  render() {
    const {
      changeOnTap,
      checked,
      colors,
      onChange,
      disabled,
      "aria-label": ariaLabel,
    } = this.props;

    return (
      <Switch
        changeOnTap={changeOnTap}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        uncheckedIcon={null}
        checkedIcon={null}
        offColor="#888"
        onColor={lighten(0.275, colors.PRIMARY)}
        offHandleColor="#fff"
        onHandleColor={colors.PRIMARY}
        boxShadow={`0 1px 2px 2px rgba(0, 0, 0, ${
          // Making the shadow match the darken amount in activeBoxShadow
          // so that the transition looks kinda cool
          ACTIVE_DARKEN_AMOUNT
        })`}
        activeBoxShadow={`0 0 0 5px rgba(0, 0, 0, ${ACTIVE_DARKEN_AMOUNT})`}
        handleDiameter={20}
        height={14}
        width={36}
        aria-label={ariaLabel}
      />
    );
  }
}

type Props = {
  changeOnTap?: boolean,
  checked?: ?boolean,
  colors: ColorSet,
  onChange?: (newValue: boolean) => void,
  disabled?: boolean,
  "aria-label"?: string,
  forceType?: "iOS" | "Android",
};

class Toggle extends React.Component<Props> {
  render() {
    const {
      changeOnTap,
      checked,
      colors,
      onChange,
      disabled,
      "aria-label": ariaLabel,
      forceType,
    } = this.props;

    let ToggleComponent = UserAgent.isIOS() ? IOSToggle : AndroidToggle;
    if (forceType === "iOS") {
      ToggleComponent = IOSToggle;
    } else if (forceType === "Android") {
      ToggleComponent = AndroidToggle;
    }

    return (
      <ToggleComponent
        changeOnTap={changeOnTap}
        checked={checked || false}
        colors={colors}
        onChange={
          onChange ||
          (() => {
            /* no-op */
          })
        }
        disabled={disabled}
        aria-label={ariaLabel || undefined}
      />
    );
  }
}

export default withColorsProvider(Toggle);



// WEBPACK FOOTER //
// ../nx-components/src/Toggle.jsx